import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { parseIntSafe } from "@modules/common/functions/parse-int-safe";
import { ZendeskSSOQueryParams } from "@modules/login-zendesk-sso/models/zendesk-sso-query-params";

@Injectable({
    providedIn: 'root'
})
export class ZendeskSSOQueryParamsService {
    constructor(private readonly _router: Router) { }

    /**
     * Gets the Zendesk SSO query parameters from the given route, or the current route if no route is provided.
     * If any of the expected query parameters are missing or invalid, this returns undefined.
     */
    public getZendeskSSOQueryParams(route?: ActivatedRouteSnapshot): ZendeskSSOQueryParams | undefined {
        route ??= this._router.routerState.snapshot.root;

        const email = this.getQueryParam(route, 'email');
        const time = parseIntSafe(this.getQueryParam(route, 'time'));
        const mac = this.getQueryParam(route, 'mac');

        if (!email || !time || !mac) {
            return undefined;
        }

        return {
            email: email,
            time: time,
            mac: mac,
        };
    }

    private getQueryParam(route: ActivatedRouteSnapshot, queryParamName: keyof ZendeskSSOQueryParams): string | undefined {
        return route.queryParams[queryParamName];
    }
}